"use strict";

module.exports = () => {
    $("div:not(.product-info).card[data-parent-uuid]").each((i, e) => {
        const $this = $(e);
        const dataParentUUID = $this.attr("data-parent-uuid");

        if (dataParentUUID.length > 0) {
            var $cardStringingContainer = $("div#" + dataParentUUID);

            $this.appendTo($cardStringingContainer);

            if (!$cardStringingContainer.hasClass("populated")) {
                $cardStringingContainer.addClass("populated");
            }
        }
    });
};
